module.exports = __webpack_public_path__ + "image/detail_image_mobile_acd2e.png";